module.exports = __webpack_public_path__ + "img/corenroll-logo.5b46dfa0.png";